import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import {Box} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  font:{
    fontSize:'18px'

  },
  image: {
    boxShadow:
      '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const  Sitesaturation= props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} marginLeft= {2} marginRight={2} marginTop= {2} display="flex" justifyContent="space-evenly" alignItems="center" padding={5} border="1px solid #ccc" borderRadius="4px">
      <Grid
     
        container
        justify="space-between"
        spacing={4}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <SectionHeader
            title={
              <span>
              Single cell resolution to maximize biological insight
                <br />
                <Typography component="span" variant="inherit" color="primary">
                 Dna Data Storage
                </Typography>
              </span>
            }
            subtitle="Unleash the full power of a well-designed library. With Twist, you are assured that the library you design contains the specific modifications, exactly where you want them, saving you valuable resources for the downstream screening process. 

            Precisely crafted .
          
            "
     
            align="left"
            disableGutter
            titleVariant="h3"
          />
          <ul  className = {classes.font}>
        
            <li >
       
            Superior precision and diversity compared to random mutagenesis or site directed mutagenesis 
           
            </li>
            <li>
      
            No introduction of stop or unwanted codons 
           

            </li>
            <li>
            Precise codon ratio control 

     

            </li>
            <li>

            Fast turnaround time 
           

            </li>
            <li>

            More cost effective than recombinatorial mutagenesis Superior Quality 

            </li>
            <li>
            All Site Saturation Libraries are NGS-verified 
            </li>
            
            <li>
            Documentation showing the percentage ratio of amino acid variation at each position is included 
            </li>
<li>
Rigorous quality control and verification of all variants 
</li>
<li>
Three delivery format options to meet your needs 
</li>
          </ul>
          <SectionHeader
             ctaGroup={[
              <Button variant="contained" color="primary" size="large">
                Start now
              </Button>,
              <Button variant="outlined" color="primary" size="large">
                Learn more
              </Button>,
            ]}
            align="left"
            disableGutter
            titleVariant="h3"
            />
        </Grid>
        <Grid
          item
          container
          justify="flex-start"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="https://ik.imagekit.io/j6phbjneuop/Twist/ss_phuovtjy3.png?updatedAt=1627463552966"
            alt="dna storage"
            className={classes.image}
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

Sitesaturation.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Sitesaturation;
